import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminGuard } from 'src/app/shared/guard/admin.guard';
import { PageComponent } from './page/page.component';
import { CryptoGuard } from 'src/app/shared/guard/crypto.guard';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'dashboard/home',
        title: 'New Home',
        component: PageComponent,
        canActivate: [AdminGuard, CryptoGuard],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class HomeRoutingModule {}
